module.exports = new __parcel__URL__("add-comment-dark.948afc30.svg").toString();